import {
  Col,
  Row,
  Space,
  Table,
  Tag,
  Card,
  Button,
  message,
  Spin,
  Select,
  Typography,
  Tooltip,
  Input,
} from "antd";
import React, { useEffect, useMemo, useState } from "react";
import {
  CloseCircleOutlined,
  SearchOutlined,
  UpSquareOutlined,
  DownSquareOutlined,
  ReloadOutlined,
  PrinterOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import { baseUrl, GET_LAND_BY_DATE, HEADERS_EXPORT } from "../../API/apiUrls";
import axios from "axios";
import DateCustom from "../../../hook/DateCustom";
import dayjs from "dayjs";
import { optionsLocat } from "../../../utils/constant/LocatOption";
import { ThaiRangePicker } from "../../../hook/ThaiDatePickerNew";
import AssetsSummary from "./modal/AssetsSummary";
import { printInvestigationReportList } from "./report/ReportSumaryResult";
import LoadLawyers from "../../../hook/LoadLawyers";
import { printLandReportPerProperty } from "./report/ReportAssets";

const Main = () => {
  const { Option } = Select;
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [convertDateThai] = DateCustom();
  const [isModal, setIsModal] = useState(false);
  const [arrayTable, setArrayTable] = useState();
  const [dataArr, setDataArr] = useState();
  const [loading, setLoading] = useState(false);
  const [dataModal, setDataModal] = useState();
  const [tableLength, setTableLength] = useState(0);
  const [isModalAssestsSummary, setIsModalAssestsSummary] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [statusId, setStatusId] = useState();
  const [advanceSearch, setAdvanceSearch] = useState(true);
  const [advanceFillter, setAdvanceFillter] = useState(false);
  const [datePickerInvestigateAsset, setDatePickerInvestigateAsset] =
    useState();
  const [searchInput, setSearchInput] = useState();
  const [arrow, setArrow] = useState("Show");
  const toggle = () => setAdvanceSearch((v) => !v);
  const toggleFilter = () => setAdvanceFillter((v) => !v);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
  });
  const [lawyerId, setLawyerId] = useState();
  const [lawyerName, setLawyerName] = useState();
  const [lawyersOption, setLawyersOption] = useState();
  const [lawyersList, setLoadingData] = LoadLawyers();
  const [
    datePickerInvestigateAssetSearch,
    setDatePickerInvestigateAssetSearch,
  ] = useState(() => [
    dayjs().subtract(1, "month").date(11).endOf("day"), // 10 ของเดือนหน้า
    dayjs().date(10).startOf("day"), // 11 ของเดือนนี้
  ]);

  useEffect(() => {
    setLoadingData(true);
  }, []);

  useEffect(() => {
    if (lawyersList) {
      setOptionLawyer();
    }
  }, [lawyersList]);

  const setOptionLawyer = () => {
    let companySelect = null;

    console.log(userCompany);

    if (userCompany === "3") {
      companySelect = lawyersList.filter(
        (item) =>
          item.COMPANY_ID === 3 &&
          (item.ROLE_ID === 3 || item.ROLE_ID === 4 || item.ROLE_ID === 2) &&
          item.ACTIVE_STATUS === 1,
      );
    } else {
      companySelect = lawyersList.filter(
        (item) =>
          (item.COMPANY_ID === 1 || item.COMPANY_ID === 2) &&
          (item.ROLE_ID === 3 || item.ROLE_ID === 4) &&
          item.ACTIVE_STATUS === 1,
      );
    }
    const options = companySelect.map((item) => ({
      value: item.id,
      label: item.NNAME,
      fNmae: item.FNAME,
      lName: item.LNAME,
    }));

    options.unshift({
      value: "all", // ค่าที่แทน "ทั้งหมด"
      label: "ทั้งหมด", // ข้อความที่แสดงใน dropdown
    });

    let lawyerDefualt;
    if (userCompany === "3") {
      lawyerDefualt = 10;
    } else {
      lawyerDefualt = 3;
    }

    let lawyerSet = lawyersList.find((item) => item.id === lawyerDefualt);
    setLawyerName(lawyerSet);

    setLawyersOption(options);
  };

  const idToLawyer = React.useMemo(() => {
    // คัดตามกฎเดียวกับ setOptionLawyer
    const byCompany = (l) =>
      userCompany === "3"
        ? l.COMPANY_ID === 3 && [2, 3, 4].includes(l.ROLE_ID)
        : [1, 2].includes(l.COMPANY_ID) && [3, 4].includes(l.ROLE_ID);

    const active = (l) => l.ACTIVE_STATUS === 1;

    const map = new Map();
    (lawyersList || [])
      .filter((l) => byCompany(l) && active(l))
      .forEach((l) => {
        map.set(l.id, {
          nick: l.NNAME,
          full: `${l.FNAME ?? ""} ${l.LNAME ?? ""}`.trim(),
        });
      });
    return map;
  }, [lawyersList, userCompany]);

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const queryData = async () => {
    setAdvanceFillter(false);

    const [start, end] = datePickerInvestigateAssetSearch || [];
    const dStart = dayjs(start);
    const dEnd = dayjs(end);

    if (!dStart.isValid() || !dEnd.isValid()) {
      message.error("โปรดระบุช่วงวันที่ให้ครบ");
      return;
    }
    if (dEnd.isBefore(dStart, "day")) {
      message.error("วันสิ้นสุดต้องไม่น้อยกว่าวันเริ่มต้น");
      return;
    }

    const payload = {
      dateStart: dStart.format("YYYY-MM-DD"),
      dateEnd: dEnd.format("YYYY-MM-DD"),
    };

    await loadData(payload);
  };

  const loadData = async (params) => {
    setLoading(true);
    console.log(params);

    try {
      await axios
        .get(baseUrl + GET_LAND_BY_DATE, { params, headers: HEADERS_EXPORT })
        .then(async (res) => {
          let i = 1;
          if (res.status === 200) {
            const newData = res.data.map((item) => ({
              ...item,
              key: i++,
            }));
            filterData(newData);
            setAdvanceFillter(true);
            console.log("res Role", newData);
          } else {
            message.error("ไม่มีข้อมูล");
            console.log("res Role", res.data);
          }
        })
        .catch((err) => {
          console.log("ไม่มีข้อมูล", err); // ถ้ามีข้อผิดพลาดอื่น ๆ ให้แสดงข้อความนี้
          message.error("ไม่มีข้อมูล");
          setArrayTable([]);
          setDataArr([]);
        });
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
      setArrayTable([]);
      setDataArr([]);
    } finally {
      setLoading(false);
    }
  };

  const filterData = (data) => {
    if (data) {
      let filteredData;
      console.log("data", data);

      if (userCompany === "3") {
        filteredData = data.filter((item) => {
          const branch = item.LOCAT;
          // ถ้า branch เป็น null หรือ undefined ให้ return true ไปเลย (หรือ false ก็ได้ ขึ้นกับความต้องการ)
          if (!branch) return true; // หรือ false ก็ได้ ถ้าอยาก "กรองออก"

          // ถ้า branch มีค่า → เช็กตามปกติ
          return (
            !optionsLocat.some((opt) => branch.includes(opt.label)) ||
            item.CONTNO.includes("UD")
          );
        });
      } else {
        filteredData = data.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return false; // ไม่มี branch ไม่ผ่านเงื่อนไข

          return optionsLocat.some((opt) => branch.includes(opt.label));
        });
      }

      const newData = filteredData.filter(
        (item) =>
          item.investigation_status === 0 ||
          item.investigation_status === 1 ||
          item.judge_date,
      );
      console.log("filteredData", filteredData);

      const sortedData = newData.sort((a, b) => {
        // ถ้า a ไม่มี judge_date ให้เอาไว้ล่าง
        if (!a.investigation_date && b.investigation_date) return 1;
        // ถ้า b ไม่มี judge_date ให้เอาไว้ล่าง
        if (a.investigation_date && !b.investigation_date) return -1;
        // ถ้าทั้งคู่มี judge_date ให้เปรียบเทียบปกติ (ล่าสุดก่อน)
        if (a.investigation_date && b.investigation_date) {
          return (
            new Date(a.investigation_date) - new Date(b.investigation_date)
          );
        }
        return 0; // ถ้าทั้งคู่เป็น null
      });

      setArrayTable(sortedData);
      setDataArr(newData);
      setTableLength(sortedData?.length);
      console.log("newData", sortedData);
      console.log("Length of filtered data:", sortedData?.length);
    } else {
      console.error("data is not an array or is undefined");
      setTableLength(0);
    }
  };

  const onExpand = (expanded, record) => {
    if (expanded) {
      // เมื่อแถวถูกขยาย, ให้เพิ่ม key ของแถวนั้นลงใน expandedRowKeys
      setExpandedRowKeys([record.key]);
    } else {
      // เมื่อแถวถูกยุบ, ให้ลบ key ของแถวนั้นออกจาก expandedRowKeys
      setExpandedRowKeys([]);
    }
  };

  //ทำ render record ของตาราถ้าใช้ logic เยอะ
  const renderDataAssetBefor = (record) => {
    let color =
      record.investigation_status === 0
        ? "red"
        : record.investigation_status === 1
          ? "green"
          : record.investigation_status === 2
            ? "orange"
            : record.investigation_status === null
              ? "blue"
              : null;

    return (
      <Tag color={color} key={record.id} style={{ textAlign: "center" }}>
        สืบรอบที่ {record.round_no}
        <br />
        {record.investigation_status === 0
          ? "ไม่เจอทรัพย์"
          : record.investigation_status === 1
            ? `เจอทรัพย์ ${record.property_list.length} แปลง`
            : record.investigation_status === 2
              ? `อายัดเงินได้`
              : record.investigation_status === 5
                ? "ดำเนินการ"
                : record.investigation_status === 6
                  ? "ไม่เจอทรัพย์"
                  : record.investigation_status === 7
                    ? "เจอทรัพย์"
                    : record.investigation_status === null
                      ? "ยังไม่สืบทรัพย์"
                      : null}
        <br />
      </Tag>
    );
  };

  const renderOpteionStatus = () => {
    return (
      <>
        <Option value={4}>
          <span style={{ marginRight: 8 }}>🗂️</span>
          ทั้งหมด
        </Option>
        <Option value={1}>
          <CloseCircleOutlined style={{ color: "red", marginRight: 8 }} />
          ไม่เจอทรัพย์
        </Option>
        <Option value={2}>✅ เจอทรัพย์/อายัดเงินได้</Option>
      </>
    );
  };

  const onChangeSelectStatus = (value) => {
    console.log("onChangeSelectStatus-->", value);
    // onSearchStatus(value);
    setStatusId(value);
  };

  const onChangeInvestigateDate = (dates) => {
    setDatePickerInvestigateAsset(dates);

    console.log(datePickerInvestigateAsset);
  };

  const onChangeInvestigateDateSearch = (dates) => {
    setDatePickerInvestigateAssetSearch(dates);
  };

  //ทำ render record ของตาราถ้าใช้ logic เยอะ
  const renderDate = (record, inves) => {
    //ส่งค่า null ออกไปถ้า record นี่ยังไม่มี
    if (!record.investigation_date) {
      return null;
    }
    let color;
    const recordDate = dayjs(record.investigation_date);
    const today = dayjs().startOf("day");

    // คำนวณความแตกต่างในหน่วยปี
    const yearsDifference = today.diff(recordDate, "year");

    // คำนวณความแตกต่างในหน่วยเดือน
    const monthsDifference = today.diff(recordDate, "month");

    // คำนวณความแตกต่างในหน่วยวัน
    const daysDifference = today.diff(recordDate, "day");

    // คำนวณส่วนที่เหลือหลังจากคำนวณปีแล้ว (คำนวณเดือนที่เหลือ)
    const remainingMonths = today
      .subtract(yearsDifference, "year")
      .diff(recordDate, "month");

    // คำนวณส่วนที่เหลือหลังจากคำนวณปีและเดือนแล้ว (คำนวณวันที่เหลือ)
    const remainingDays = today
      .subtract(yearsDifference, "year")
      .subtract(remainingMonths, "month")
      .diff(recordDate, "day");

    if (record.investigation_status === 0) {
      color = yearsDifference >= 1 ? "orange" : "red";
    } else if (record.investigation_status === 1) {
      color = "green";
    } else if (record.investigation_status === 2) {
      color = "green";
    } else {
      color = "blue";
    }
    const formattedDate = record.investigation_date
      ? convertDateThai(recordDate)
      : null;
    return (
      <Tag color={color} key={daysDifference} style={{ textAlign: "center" }}>
        {formattedDate}
        <br />
        {
          <span>
            {yearsDifference} ปี {remainingMonths} เดือน {remainingDays} วัน
          </span>
        }
        <br />
        {inves ? <span>ที่ {record.department_of_lands} </span> : null}
      </Tag>
    );
  };

  const renderDateJudge = (record) => {
    //ส่งค่า null ออกไปถ้า record นี่ยังไม่มี
    if (!record.judge_date) {
      return null;
    }
    let color;
    const recordDate = dayjs(record.judge_date);
    const today = dayjs().startOf("day");

    // คำนวณความแตกต่างในหน่วยปี
    const yearsDifference = today.diff(recordDate, "year");

    // คำนวณความแตกต่างในหน่วยเดือน
    const monthsDifference = today.diff(recordDate, "month");

    // คำนวณความแตกต่างในหน่วยวัน
    const daysDifference = today.diff(recordDate, "day");

    // คำนวณส่วนที่เหลือหลังจากคำนวณปีแล้ว (คำนวณเดือนที่เหลือ)
    const remainingMonths = today
      .subtract(yearsDifference, "year")
      .diff(recordDate, "month");

    // คำนวณส่วนที่เหลือหลังจากคำนวณปีและเดือนแล้ว (คำนวณวันที่เหลือ)
    const remainingDays = today
      .subtract(yearsDifference, "year")
      .subtract(remainingMonths, "month")
      .diff(recordDate, "day");

    if (remainingMonths >= 1 || yearsDifference > 0) {
      color = "orange";
    } else if (remainingMonths < 1) {
      color = "blue";
    } else if (remainingMonths > 12) {
      color = "red";
    }

    const formattedDate = record.judge_date
      ? convertDateThai(recordDate)
      : null;
    return (
      <Tag color={color} key={daysDifference} style={{ textAlign: "center" }}>
        {formattedDate}
        <br />
        {
          <span>
            {yearsDifference} ปี {remainingMonths} เดือน {remainingDays} วัน
          </span>
        }
      </Tag>
    );
  };

  const onQueryDataFilter = () => {
    let result = [...dataArr];
    clearSelectedRows();
    console.log(searchInput);

    if (searchInput && searchInput.trim() !== "") {
      const keyword = searchInput.trim();

      result = result.filter(
        (item) =>
          (item.CONTNO && item.CONTNO.includes(keyword)) ||
          (item.CUSTOMER_LNAME && item.CUSTOMER_LNAME.includes(keyword)) ||
          (item.CUSTOMER_FNAME && item.CUSTOMER_FNAME.includes(keyword)),
      );
    }

    // filter จาก select (statusId)
    if (statusId) {
      if (statusId === 1) {
        result = result.filter((item) => item.investigation_status === 0);
      } else if (statusId === 2) {
        result = result.filter((item) => item.investigation_status === 1);
      } else if (statusId === 3) {
        result = result.filter(
          (item) => item.investigation_status === null && item.judge_date,
        );
      }
    }
    if (lawyerId) {
      if (lawyerId !== "all") {
        result = result.filter((item) => item.investigator_id === lawyerId);
      }
    }

    if (datePickerInvestigateAsset && datePickerInvestigateAsset.length === 2) {
      const start = dayjs(datePickerInvestigateAsset[0])
        .startOf("day")
        .valueOf();
      const end = dayjs(datePickerInvestigateAsset[1]).endOf("day").valueOf();

      result = result.filter((item) => {
        const date = dayjs(item.investigation_date).valueOf();
        return date >= start && date <= end;
      });
    }
    console.log("result", result);

    if (result.length > 0) {
      setArrayTable(result);
      setTableLength(result.length);
    } else {
      message.error("ไม่พบข้อมูล");
      setArrayTable(result);
      setTableLength(result.length);
    }
  };

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    console.log("selectedRowKeys changed: ", selectedRowKeys);
    setSelectedRowKeys(selectedRowKeys);
    console.log("Selected Row Keys:", selectedRowKeys); // คีย์ของแถวที่เลือก
    console.log("Selected Rows Data:", selectedRows); // ข้อมูลของแถวที่เลือก
    setSelectedRows(selectedRows); // เก็บข้อมูลแถวที่เลือกใน state;
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (rowKeys, selectedRows) => {
      onSelectChange(rowKeys, selectedRows);
    },
  };

  const clearSelectedRows = () => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
  };

  const onChangeSelectLawyer = (value, label) => {
    console.log("onChangeSelectLawyer-->", value, label);
    let lawyerSet = lawyersList.find((item) => item.NNAME === label.label);
    setLawyerName(lawyerSet);
    setLawyerId(value);
  };

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: "10%",
      render: (text, object, key) => key + 1,
      sorter: {
        compare: (a, b) => a.key - b.key,
        multiple: 5,
      },
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (text, record) => (
        // <Link
        //   onClick={() => {
        //     setIsModal(true);
        //     setDataRecord(record);
        //   }}
        // >
        <>
          {" "}
          {record.CONTNO ? record.CONTNO : null}
          {record.NEW_CONTNO ? (
            <>
              <br />
              <span style={{ fontSize: 12, color: "gray" }}>
                เลขสัญญาใหม่: {record.NEW_CONTNO}
              </span>
            </>
          ) : null}
        </>
        // </Link>
      ),
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "CUSTOMER_TNAM",
      key: "CUSTOMER_TNAM",
      align: "center",
      render: (text, record) => (
        <>
          {record.CUSTOMER_TNAME ? record.CUSTOMER_TNAME : null}{" "}
          {record.CUSTOMER_FNAME ? record.CUSTOMER_FNAME : null}{" "}
          {record.CUSTOMER_LNAME ? record.CUSTOMER_LNAME : null}
        </>
      ),
    },
    {
      title: "วันที่พิพากษา",
      align: "center",
      render: (record) => <>{renderDateJudge(record)}</>,
    },
    {
      title: "สถานะ",
      align: "center",
      render: (record) => <>{renderDataAssetBefor(record)}</>,
    },
    {
      title: "วันที่สืบทรัพย์",
      align: "center",
      render: (record) => <>{renderDate(record, true)}</>,
      // sorter: (a, b) => {
      //   // กรณีถ้า a.investigation_date เป็น null ให้ขึ้นก่อน
      //   if (a.investigation_date === null) return -1;
      //   if (b.investigation_date === null) return 1;

      //   // เปรียบเทียบวันที่ระหว่าง a.investigation_date และ b.investigation_date
      //   const dateA = dayjs(a.investigation_date);
      //   const dateB = dayjs(b.investigation_date);

      //   if (dateA.isBefore(dateB)) return -1;
      //   if (dateA.isAfter(dateB)) return 1;
      //   return 0; // ถ้าเท่ากัน
      // },
      // defaultSortOrder: "ascend", // กำหนดการเรียงลำดับเริ่มต้น
      // sortDirections: ["ascend", "descend"], // เพิ่มการรองรับการสลับลำดับ
    },
    {
      title: "ผู้รับผิดชอบ",
      dataIndex: "investigator_id",
      key: "investigator_id",
      align: "center",
      render: (id, record) => {
        const lawyer = idToLawyer.get(typeof id === "string" ? Number(id) : id);
        return lawyer ? (
          <>{lawyer.nick /* หรือ lawyer.full ถ้าอยากแสดงชื่อ-นามสกุลเต็ม */}</>
        ) : (
          <span style={{ color: "#999" }}>-</span>
        );
      },
    },
  ];

  return (
    <>
      <Card>
        <Space direction="horizontal" size={8}>
          <Tooltip
            title={advanceFillter ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
            arrow={mergedArrow}
          >
            {!advanceFillter ? (
              <DownSquareOutlined
                style={{ fontSize: 20, color: "blue", marginTop: 20 }}
                onClick={toggleFilter} // antd ส่งค่า checked มาให้
              />
            ) : (
              <UpSquareOutlined
                style={{ fontSize: 20, color: "blue", marginTop: 35 }}
                onClick={toggleFilter} // antd ส่งค่า checked มาให้
              />
            )}
          </Tooltip>
          <Space direction="vertical" size={8} style={{ marginRight: 10 }}>
            <Typography.Text strong>ห้วงเวลาค้นหาข้อมูล</Typography.Text>
            <ThaiRangePicker
              value={datePickerInvestigateAssetSearch}
              onChange={onChangeInvestigateDateSearch}
              size="large"
            />
          </Space>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            size="large"
            style={{
              borderRadius: "8px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              fontWeight: "bold",
              background: "linear-gradient(135deg, #667eea, blue)",
              border: "none",
              marginTop: 30,
            }}
            onClick={queryData}
            loading={loading}
          >
            ค้นหา
          </Button>
        </Space>
      </Card>
      {advanceFillter ? (
        <Card>
          <Row>
            <Col
              span={"12"}
              style={{ textAlign: "start", marginBottom: "10px" }}
            >
              <Space direction="vertical" size={8} style={{ marginRight: 10 }}>
                <Typography.Text strong>
                  ค้นหาสัญญา / ชื่อ-นามสกุล
                </Typography.Text>
                <Input
                  placeholder="ค้นหาสัญญา"
                  onChange={(e) => {
                    setSearchInput(e.target.value);
                  }}
                  style={{
                    width: 200,
                    marginRight: 10,
                  }}
                  value={searchInput}
                  size="large"
                />
              </Space>
              <Space direction="vertical" size={8} style={{ marginRight: 10 }}>
                <Typography.Text strong>ค้นหาสถานะ</Typography.Text>
                <Select
                  placeholder="เลือกสถานะ"
                  optionFilterProp="value"
                  popupMatchSelectWidth={false}
                  onChange={(value) => onChangeSelectStatus(value)}
                  style={{
                    width: "auto",
                  }}
                  size="large"
                  value={statusId}
                >
                  {renderOpteionStatus()}
                </Select>
              </Space>
              <Space direction="vertical" size={8} style={{ marginRight: 10 }}>
                <Typography.Text strong>เลือกทนาย</Typography.Text>

                <Select
                  placeholder="เลือกทนาย"
                  showSearch
                  optionFilterProp="label"
                  onChange={(value, label) =>
                    onChangeSelectLawyer(value, label)
                  }
                  options={lawyersOption}
                  value={lawyerId}
                  style={{
                    width: 150,
                    marginRight: "10px",
                  }}
                  size="large"
                />
              </Space>
            </Col>
            <Col span={"12"} style={{ textAlign: "end", marginBottom: "10px" }}>
              <Space direction="horizontal" size={8}>
                <Tooltip
                  title={advanceSearch ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
                  arrow={mergedArrow}
                >
                  {!advanceSearch ? (
                    <DownSquareOutlined
                      style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                      onClick={toggle} // antd ส่งค่า checked มาให้
                    />
                  ) : (
                    <UpSquareOutlined
                      style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                      onClick={toggle} // antd ส่งค่า checked มาให้
                    />
                  )}
                </Tooltip>
                <Button
                  icon={<ReloadOutlined />}
                  onClick={() => {
                    setSearchInput(null);
                    setStatusId(null);

                    setDatePickerInvestigateAsset(null);
                    setLawyerId(null);
                    setLawyerName(null);
                  }}
                  style={{
                    color: "red",
                    borderRadius: "8px",
                    fontWeight: "bold",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  ล้าง
                </Button>
                <Button
                  type="default"
                  icon={<FilterOutlined />}
                  size="large"
                  style={{
                    borderRadius: "8px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    fontWeight: "bold",
                    backgroundColor: "#fff7d6",
                    color: "#333",
                    border: "1px solid #ffe58f",
                  }}
                  onClick={onQueryDataFilter}
                  disabled={loading}
                >
                  กรองข้อมูล
                </Button>
              </Space>
            </Col>

            {advanceSearch ? (
              <Col span={24} style={{ textAlign: "start" }}>
                <Space direction="vertical" size={8}>
                  <Typography.Text strong>
                    ค้นหาจากวันที่สืบทรัพย์
                  </Typography.Text>
                  <ThaiRangePicker
                    value={datePickerInvestigateAsset}
                    onChange={onChangeInvestigateDate}
                    size="large"
                  />
                </Space>
              </Col>
            ) : null}
          </Row>
        </Card>
      ) : null}
      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row>
            <Col span={"24"} style={{ textAlign: "end" }}>
              <Button
                icon={<PrinterOutlined />}
                // disabled={selectedRows.length === 0}
                onClick={() => {
                  if (selectedRows.length) {
                    printInvestigationReportList(selectedRows);
                  } else {
                    printInvestigationReportList(arrayTable);
                  }
                }}
                style={{
                  color: "green",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  marginBottom: 10,
                }}
              >
                พิมพ์
              </Button>
            </Col>
            <Col span={"24"}>
              <Table
                size="small"
                columns={columns}
                rowSelection={rowSelection}
                dataSource={arrayTable}
                scroll={{ x: 850 }}
                pagination={{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "50", "100"],
                  onChange: (page, pageSize) => {
                    setPagination({ current: page, pageSize });
                  },
                }}
                footer={() => <p>จำนวนสัญญาทั้งหมด {tableLength}</p>}
                expandable={{
                  expandedRowRender: (record) => (
                    <p style={{ margin: 0 }}>
                      <>
                        <Button
                          style={{
                            boxShadow: "0 4px 3px",
                            marginRight: "10px",
                            color: "blue",
                          }}
                          onClick={() => {
                            setIsModalAssestsSummary(true);
                            setDataModal(record);
                          }}
                        >
                          เรียกดู
                        </Button>
                        <Button
                          style={{
                            boxShadow: "0 4px 3px",
                            marginRight: "10px",
                            color: "green",
                          }}
                          onClick={() => {
                            printLandReportPerProperty(record);
                            console.log(record);
                          }}
                        >
                          พิมพ์
                        </Button>
                      </>
                    </p>
                  ),
                  rowExpandable: (record) => record,
                  expandedRowKeys, // เก็บ state ของ row ที่ขยาย
                  onExpand, // ฟังก์ชันที่ควบคุมการขยาย
                }}
                rowKey="key"
              />
            </Col>
          </Row>
        </Spin>
      </Card>
      {isModalAssestsSummary ? (
        <AssetsSummary
          open={isModalAssestsSummary}
          close={setIsModalAssestsSummary}
          dataDefualt={dataModal}
          //   funcUpdateStatus={handleUpdateData}
        />
      ) : null}
    </>
  );
};

const ReportInvestigateAssets = MotionHoc(Main);
export default ReportInvestigateAssets;
